import React from 'react'
import AccountHelperForm from '../Contents/AccountHelper/AccountHelperForm'

function AccountHelper() {
  return (
    <div>
      <AccountHelperForm />
    </div>
  )
}

export default AccountHelper
